import { createContext } from "react";
import { TimeSlot } from "../components/slot-card/types";
import { Dispatch } from "@reduxjs/toolkit";

//types
export interface UserAppointmentState {
  user: any;
  isUserExisted: boolean;
  selectedPets: any[];
  clientsList: any[];
  activeStep: number;
  timeSlots: any;
  selectedTimeSlot: any;
  selectedClientAccount: any | null;
  appointmentTypes: any | null;
  provider: any;
  updateUserMeta: boolean;
}

export type UserAppointmentAction =
  | { type: "SET_USER"; payload: any }
  | { type: "SET_IS_USER_EXISTED"; payload: boolean }
  | { type: "SET_SELECTED_PETS"; payload: any[] }
  | { type: "SET_CLIENTS_LIST"; payload: any[] }
  | { type: "SET_ACTIVE_STEP"; payload: number }
  | { type: "SET_TIME_SLOTS"; payload: any }
  | { type: "SET_SELECTED_TIME_SLOT"; payload: TimeSlot | null }
  | { type: "SET_SELECTED_CLIENT_ACCOUNT"; payload: any | null }
  | { type: "SET_APPOINTMENT_TYPES"; payload: any | null }
  | { type: "SET_PROVIDER"; payload: any | null }
  | { type: "UPDATE_USER_META"; payload: any | null }
  | { type: "RESET_STATE" };

//states
export const USER_APPOINTMENT_ACTIONS = {
  SET_USER: "SET_USER",
  SET_IS_USER_EXISTED: "SET_IS_USER_EXISTED",
  SET_SELECTED_PETS: "SET_SELECTED_PETS",
  SET_CLIENTS_LIST: "SET_CLIENTS_LIST",
  SET_ACTIVE_STEP: "SET_ACTIVE_STEP",
  SET_TIME_SLOTS: "SET_TIME_SLOTS",
  SET_SELECTED_TIME_SLOT: "SET_SELECTED_TIME_SLOT",
  SET_SELECTED_CLIENT_ACCOUNT: "SET_SELECTED_CLIENT_ACCOUNT",
  SET_APPOINTMENT_TYPES: "SET_APPOINTMENT_TYPES",
  SET_PROVIDER: "SET_PROVIDER",
  RESET_STATE: "RESET_STATE",
  UPDATE_USER_META: "UPDATE_USER_META",
} as const;

export const initialState: UserAppointmentState = {
  user: {},
  isUserExisted: false,
  selectedPets: [],
  clientsList: [],
  activeStep: 1,
  timeSlots: null,
  selectedTimeSlot: null,
  selectedClientAccount: null,
  appointmentTypes: [],
  provider: {},
  updateUserMeta: false,
};

export const reducer = (
  state: UserAppointmentState,
  action: UserAppointmentAction
): UserAppointmentState => {
  switch (action.type) {
    case USER_APPOINTMENT_ACTIONS.SET_USER:
      return { ...state, user: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_IS_USER_EXISTED:
      return { ...state, isUserExisted: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_SELECTED_PETS:
      return { ...state, selectedPets: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_CLIENTS_LIST:
      return { ...state, clientsList: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_ACTIVE_STEP:
      return { ...state, activeStep: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_TIME_SLOTS:
      return { ...state, timeSlots: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_SELECTED_TIME_SLOT:
      return { ...state, selectedTimeSlot: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_SELECTED_CLIENT_ACCOUNT:
      return { ...state, selectedClientAccount: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_APPOINTMENT_TYPES:
      return { ...state, appointmentTypes: action.payload };
    case USER_APPOINTMENT_ACTIONS.SET_PROVIDER:
      return { ...state, provider: action.payload };
    case USER_APPOINTMENT_ACTIONS.UPDATE_USER_META:
      return { ...state, updateUserMeta: action.payload };
    case USER_APPOINTMENT_ACTIONS.RESET_STATE:
      return { ...initialState };
    default:
      return state;
  }
};

export const UserAppointmentContext = createContext<{
  state: UserAppointmentState;
  userDispatcher: Dispatch<UserAppointmentAction> | any;
}>({
  state: initialState,
  userDispatcher: () => null,
});
